const BASE_URL = process.env.REACT_APP_CHAT_API_URL;

class AdminApiService {
  constructor() {
    this.secret = null;
  }

  setSecret(secret) {
    this.secret = secret;
  }

  async makeRequest(endpoint, options = {}) {
    if (!this.secret) {
      throw new Error('Admin secret not set');
    }

    const url = new URL(`${BASE_URL}${endpoint}`);
    url.searchParams.append('secret', this.secret);
    
    if (options.params) {
      Object.keys(options.params).forEach(key => {
        url.searchParams.append(key, options.params[key]);
      });
    }

    try {
      const response = await fetch(url.toString(), {
        method: options.method || 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...options.headers,
        },
        ...options,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'API request failed');
      }

      return data;
    } catch (error) {
      console.error('Admin API error:', error);
      throw error;
    }
  }

  async getDashboard() {
    return this.makeRequest('/api/admin/dashboard');
  }

  async getChats(limit = 500) {
    return this.makeRequest('/api/admin/chats', {
      params: { limit }
    });
  }

  async getTools(limit = 50) {
    return this.makeRequest('/api/admin/tools', {
      params: { limit }
    });
  }

  async getUsers(limit = 50) {
    return this.makeRequest('/api/admin/users', {
      params: { limit }
    });
  }

  async getAnalytics() {
    return this.makeRequest('/api/admin/analytics');
  }

  async getStatus() {
    return this.makeRequest('/api/admin/status');
  }

  async getSession(sessionId) {
    return this.makeRequest(`/api/admin/sessions/${sessionId}`);
  }

  async search(query, type = 'all') {
    return this.makeRequest('/api/admin/search', {
      params: { q: query, type }
    });
  }
}

const adminApi = new AdminApiService();
export default adminApi;